__webpack_require__.p = "https://ui.beta.us-east-1.urc.advertising.amazon.dev/";